import React from 'react';
import thumbnail from '../../../assets/images/video_thumbnail.png';
import './style.scss';
const VideoSlide = () => {
  return (
    <div className='max-w-[589px] flex flex-col justify-center items-center mt-4 mx-auto'>
      <div className='flex justify-center items-center video_heading'>
        <p className='text-[20px] md:text-[28px]'>Explainer video</p>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] top-[-10px] left-[-10px]'></div>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] top-[-10px] right-[-10px]'></div>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] bottom-[-10px] left-[-10px]'></div>
        <div className='absolute bg-[#222426] w-[13.6px] h-[13.6px] bottom-[-10px] right-[-10px]'></div>
      </div>
      <div className='w-full max-w-[589px] h-full max-h-[519px] video_body'>
        <img src={thumbnail} alt='thumbnail' className='w-full h-full' />
      </div>
    </div>
  );
};

export default VideoSlide;
